@if (isPaginationVisible()) {
  <div class="pagination">
    <div class="pagination__section">
      <a
        class="pagination-button"
        [ngClass]="getButtonClassNames(buttonFirst)"
        (click)="changePage(1, buttonFirst.isDisabled(), $event)"
        [href]="getPageUrl(1)"
        >{{ buttonFirst.name }}</a
      >
      <a
        class="pagination-button"
        [ngClass]="getButtonClassNames(buttonPrevious)"
        (click)="changePage(previousPage(), buttonPrevious.isDisabled(), $event)"
        [href]="getPageUrl(previousPage())"
      >
        {{ buttonPrevious.name }}
      </a>
    </div>
    <div class="pagination__section pagination__pages">
      @for (page of buttonsNumeric; track page) {
        <a
          class="pagination-button"
          [ngClass]="getNumericButtonClassNames(page)"
          (click)="changePage(page, false, $event)"
          [href]="getPageUrl(maxPage(page))"
          >{{ page }}</a
        >
      }
    </div>
    <div class="pagination__section">
      <a
        class="pagination-button"
        [ngClass]="getButtonClassNames(buttonNext)"
        (click)="changePage(nextPage(), buttonNext.isDisabled(), $event)"
        [href]="getPageUrl(nextPage())"
        >{{ buttonNext.name }}</a
      >
      <a
        class="pagination-button"
        [ngClass]="getButtonClassNames(buttonLast)"
        (click)="changePage(lastPage(), buttonLast.isDisabled(), $event)"
        [href]="getPageUrl(lastPage())"
        >{{ buttonLast.name }}</a
      >
    </div>
  </div>
}
